import React from 'react';

import { RootState } from 'store/store';
import { useSelector } from 'store/utils';
import { colors, fontSize } from 'styles/cp';

export const SkeletonLoader = () => {
  const cdn = useSelector((state: RootState) => state.config.endpoints.cdn);

  return (
    <div className="skeleton-loader-root">
      <div className="skeleton-loader-header">
        <img src={`${cdn}/ai-sparkles.svg`} alt="Sparkles" />
        <span className="skeleton-loader-title">Working</span>
      </div>
      <div className="skeleton-loader-line skeleton-loader-line-lg" />
      <div className="skeleton-loader-line skeleton-loader-line-lg" />
      <div className="skeleton-loader-line skeleton-loader-line-md" />
      <style jsx>{`
        .skeleton-loader-root {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 13px;
          margin-bottom: 16px;
        }
        .skeleton-loader-header {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .skeleton-loader-title {
          font-size: ${fontSize.sm};
          color: ${colors.gray};
        }
        .skeleton-loader-line {
          border-radius: 2px;
          background: ${colors.gray07};
          height: 20px;
        }
        .skeleton-loader-line-lg {
          width: 352px;
        }
        .skeleton-loader-line-md {
          width: 220px;
          margin-bottom: 0;
        }
      `}</style>
    </div>
  );
};
